import { Injectable } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import translationDe from "../../assets/i18n/de.json";
import translationEn from "../../assets/i18n/en.json";
@Injectable({
  providedIn: "root",
})
export class LanguageService {
  constructor(private readonly translate: TranslateService) {}

  private findBrowserLanguage(fallback: string): string {
    const language = window.navigator.language;
    const languageRegex = /(\w\w)-*.*/;
    const match = language.match(languageRegex);
    if (match && match.length > 1) {
      return match[1];
    } else {
      return fallback;
    }
  }

  useLanguage(language: string) {
    this.translate.use(language);
  }

  availableLanguages(): LanguageData[] {
    return [
      {
        name: "Deutsch",
        lang: "de",
      },
      {
        name: "English",
        lang: "en",
      },
    ];
  }

  initLanguage() {
    const browserLanguage = this.findBrowserLanguage("de");
    const supportedLanguages = this.availableLanguages().map((ld) => ld.lang);
    this.translate.addLangs(supportedLanguages);
    this.translate.setTranslation("de", translationDe);
    this.translate.setTranslation("en", translationEn);

    if (
      browserLanguage &&
      supportedLanguages.find((l) => l == browserLanguage)
    ) {
      this.translate.use(browserLanguage);
    } else {
      this.translate.use("de"); // XXX: not required
    }
  }
}

export interface LanguageData {
  name: string;
  lang: string;
}
